// extracted by mini-css-extract-plugin
export default {"blue07":"#00A0FE","blue02":"#1F2D42","blue03":"#8E9FAD","SidebarItem":"SidebarItemLight__SidebarItem___46PCX","active":"SidebarItemLight__active___CABw7"};